<template>
    <div id="partners">

        <DepoimentsPartiners />

        <CarouselPartiners />
    </div>
</template>

<script>
import CarouselPartiners from '../users/CarouselPartiners.vue';
import DepoimentsPartiners from '../users/DepoimentsPartiners.vue';

export default {
    components: { CarouselPartiners, DepoimentsPartiners },

}
</script>

<style scoped lang="scss">
    #partners {
        width: 100%;
        min-height: 100vh;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        padding: 0 25px;
    }

</style>
